import { apiFetch } from '../services/apiFetch';

const API_URL = import.meta.env.VITE_API_URL;

export async function fetchCompanyBranding() {
    const res = await apiFetch(`${API_URL}/api/Settings/Branding`, { method: 'GET' });
    if (!res.ok) throw new Error(`Failed to fetch company branding: ${res.status}`);
    return res.json();
}

// Company-wide dashboard reporting currency. The dashboard converts every job
// into this; invoices/expenses keep their own currencies.
export async function fetchBaseCurrency() {
    const res = await apiFetch(`${API_URL}/api/Settings/BaseCurrency`, { method: 'GET' });
    if (!res.ok) throw new Error(`Failed to fetch base currency: ${res.status}`);
    return res.json(); // { baseCurrency }
}

export async function updateBaseCurrency(baseCurrency) {
    const res = await apiFetch(`${API_URL}/api/Settings/BaseCurrency`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ baseCurrency }),
    });
    if (!res.ok) {
        const msg = await res.text().catch(() => '');
        throw new Error(msg || `Failed to update base currency: ${res.status}`);
    }
    return res.json();
}

export async function uploadLogo(file) {
    const fd = new FormData();
    fd.append('file', file);
    const res = await apiFetch(`${API_URL}/api/Settings/Logo`, { method: 'POST', body: fd });
    if (!res.ok) {
        const msg = await res.text().catch(() => '');
        throw new Error(msg || `Logo upload failed: ${res.status}`);
    }
    return res.json();
}

export async function deleteLogo() {
    const res = await apiFetch(`${API_URL}/api/Settings/Logo`, { method: 'DELETE' });
    if (!res.ok) throw new Error(`Failed to delete logo: ${res.status}`);
    return res.json();
}

export async function updateBranding(data) {
    const res = await apiFetch(`${API_URL}/api/Settings/Branding`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`Failed to update branding: ${res.status}`);
    return res.json();
}

export async function syncLogo(logoUrl) {
    await apiFetch(`${API_URL}/api/Settings/SyncLogo`, {
        method: 'POST',
        body: JSON.stringify({ logoUrl }),
    });
}

// Mirrors a Clerk org-name change into our Company.Name column. JIT
// provisioning sets the initial name; renames after that need this
// explicit sync — without it, PDFs and exports keep showing the old name.
export async function syncName(name) {
    await apiFetch(`${API_URL}/api/Settings/SyncName`, {
        method: 'POST',
        body: JSON.stringify({ name }),
    });
}

// ── Category admin ────────────────────────────────────────────────────────────

export async function fetchAdminCategories(targetType) {
    const res = await apiFetch(`${API_URL}/api/Category/AdminList/${targetType}`, { method: 'GET' });
    if (!res.ok) throw new Error(`Failed to fetch categories: ${res.status}`);
    return res.json();
}

export async function createCategory(data) {
    const res = await apiFetch(`${API_URL}/api/Category/Create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) {
        const msg = await res.text().catch(() => '');
        throw new Error(msg || `Create failed: ${res.status}`);
    }
    return res.json();
}

export async function updateCategory(id, data) {
    const res = await apiFetch(`${API_URL}/api/Category/Update/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) {
        const msg = await res.text().catch(() => '');
        throw new Error(msg || `Update failed: ${res.status}`);
    }
    return res.json();
}

export async function toggleCategoryActive(id) {
    const res = await apiFetch(`${API_URL}/api/Category/ToggleActive/${id}`, { method: 'PATCH' });
    if (!res.ok) throw new Error(`Toggle failed: ${res.status}`);
    return res.json();
}

export async function reorderCategories(data) {
    const res = await apiFetch(`${API_URL}/api/Category/Reorder`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`Reorder failed: ${res.status}`);
}
